<script>
    export default {
        name: 'PrintFriendlyResults'
    }
</script>